import type { TodoActionTelemetryData } from 'owa-todo-actions';
import type { NotificationBarHostId } from 'owa-notification-bar';
import { assertNever } from 'owa-assert';

export function getTodoContextMenuNotificationBarHostId(
    telemetryData: TodoActionTelemetryData
): NotificationBarHostId {
    const { actionSource } = telemetryData;
    switch (actionSource) {
        case 'TimePanelTodo':
        case 'TimePanelAgenda':
            return 'TimePanelNotificationBarHost';
        case 'AgendaTodo':
        case 'CalendarSurface':
        case 'CalendarAgenda':
        case 'SpacesCalendarAsset':
        case 'SpacesTaskListAsset':
        case 'SpacesTaskAsset':
        case 'TodoWidget':
            return 'CalendarModuleNotificationBarHost';
        default:
            return assertNever(actionSource);
    }
}
